export default "__VITE_ASSET__83c3c09b__"